// 禁飞区管理
export default {
    noFlyZoneName: 'Название бесполетной зоны',
    noFlyZoneDescription: 'Описание бесполетной зоны',
    addNoFlyZone: 'Добавить бесполетную зону',
    status: 'условие',
    efficient: 'эффективный',
    invalid: 'неверный',
    noFlyZoneActivationTime: 'Время активации бесполетной зоны',
    noFlyZoneValidityPeriod: 'Срок действия бесполетной зоны',
    position: 'позиция',
    tip_removeNoFlyZone: 'После удаления бесполетной зоны ее нельзя восстановить, действуйте осторожно!',
    validityPeriod: 'Срок годности',
    number: 'серийный номер',
    tip_noFlyZoneNull: 'Название запретной для полетов зоны не может быть пустым.',
    tip_noFlyZoneIllustrate: 'Описание бесполетной зоны не может быть пустым',
    tip_noFlyZonePoint: 'Добавить точки бесполетной зоны не может быть меньше трех',
    tip_selectDate: 'Пожалуйста, выберите срок действия',
}